import { css } from 'lit';

export const styles = css`
  :host { --header-h: 60px; }

  .work-orders-page {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: var(--sl-color-neutral-0);
    overflow: hidden; /* only table area scrolls */
  }

  /* Sticky header with filters */
  .header {
    background: var(--sl-color-neutral-0);
    border-bottom: 1px solid var(--sl-color-neutral-200);
    padding: 1rem;
    position: sticky;
    top: 0;
    z-index: 5;
  }

  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: .75rem;
    margin-bottom: .75rem;
  }

  .filters {
    display: grid;
    grid-template-columns: 1fr repeat(5, max-content);
    gap: .5rem;
    align-items: center;
  }

  .filters sl-input { min-width: 220px; }

  .date-filters {
    display: inline-flex;
    gap: .5rem;
    align-items: center;
  }

  /* Table area */
  .table-wrapper {
    flex: 1;
    min-height: 0;
    overflow: auto;
    padding-top: var(--header-h);      /* push below sticky header */
    scroll-padding-top: var(--header-h);
  }

  table.work-orders-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    table-layout: fixed;               /* stable widths */
    background: var(--sl-color-neutral-0);
  }

  thead th {
    position: sticky;
    top: 0;                            /* stick to top of scroll area */
    z-index: 2;
    background: var(--sl-color-neutral-0);
    border-bottom: 1px solid var(--sl-color-neutral-200);
    padding: .75rem;
    text-align: left;
    white-space: nowrap;
    user-select: none;
    box-shadow: 0 1px 0 0 var(--sl-color-neutral-200);
  }

  .column-header {
    display: inline-flex;
    align-items: center;
    gap: .5rem;
  }

  tbody tr { height: 48px; }
  tbody td {
    border-bottom: 1px solid var(--sl-color-neutral-200);
    padding: .75rem;
    vertical-align: middle;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  tr.data-row:hover { background: var(--sl-color-neutral-50); }

  /* Clickable description */
  td.desc-cell { cursor: pointer; }
  .row-caret {
    opacity: .5;
    margin-right: .25rem;
    transition: transform .15s ease, opacity .15s ease;
  }
  tr.data-row:hover .row-caret {
    opacity: 1;
    transform: translateX(2px);
  }

  /* Created column width so dates don’t clip */
  th.created-col { min-width: 140px; white-space: nowrap; }
  td.created-cell { white-space: nowrap; overflow: visible; text-overflow: clip; }

  .actions-col, .row-actions { text-align: right; white-space: nowrap; }

  /* Empty */
  .empty-state {
    text-align: center;
    padding: 2rem;
    color: var(--sl-color-neutral-500);
  }
`;
